import { MAIN_POOL_ID } from '@velocity-exchange/common';
import { useSpotMarkets } from './useSpotMarkets';

export const useIsolatedSpotToMainSpotMap = () => {
	const spotMarkets = useSpotMarkets();
	return spotMarkets.reduce(
		(acc, marketConfig) => {
			if (marketConfig.poolId === MAIN_POOL_ID) {
				return acc;
			}

			const mint = marketConfig.mint;

			const mainPoolMarketConfig = spotMarkets.find(
				(mkt) => mkt.mint.equals(mint) && mkt.poolId === MAIN_POOL_ID
			);

			if (!mainPoolMarketConfig) {
				return acc;
			}

			acc[marketConfig.marketIndex] = mainPoolMarketConfig.marketIndex;

			return acc;
		},
		{} as Record<number, number>
	);
};
